import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function Loader() {
    return (
        <div className="loader">
            <FontAwesomeIcon icon="spinner" size="2x" spin />
        </div>
    );
}

